// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.archivio-testata {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 8px 8px 4px;
  border-bottom: 1px solid var(--ion-color-light-shade, #e3e7ee);
}

.archivio-testata__titolo {
  flex: 1;
  font-size: 16px;
}

.archivio-ricerca ion-searchbar {
  padding: 8px 12px 0;
}

.archivio-lista {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 4px 12px 16px;
}

.archivio-gruppo {
  display: block;
  padding: 12px 8px 4px;
  font-size: 12px;
  font-weight: 600;
  color: var(--ion-color-medium);
  text-transform: uppercase;
}

.archivio-voce {
  display: flex;
  align-items: center;
  border-radius: 10px;
}
.archivio-voce:hover {
  background: var(--ion-color-light, #f4f6fa);
}

.archivio-voce--attiva {
  background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.1);
}

.archivio-voce__apri {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.archivio-voce__titolo {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.archivio-voce__meta {
  font-size: 12px;
  color: var(--ion-color-medium);
}

.archivio-voce__input {
  flex: 1;
  margin: 4px;
  padding: 8px;
  border: 1px solid var(--ion-color-primary);
  border-radius: 8px;
  background: transparent;
  color: inherit;
  font: inherit;
}

.archivio-errore,
.archivio-vuoto {
  display: block;
  padding: 16px 8px;
}

.archivio-vuoto {
  color: var(--ion-color-medium);
}

.archivio-spinner {
  display: block;
  margin: 12px auto;
}

.archivio-consumi {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid var(--ion-color-light-shade, #e3e7ee);
  font-size: 12px;
  color: var(--ion-color-medium-shade);
}

.archivio-voce__scopo {
  margin-right: 6px;
  padding: 0 6px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 500;
  background: var(--ion-color-primary, #3880ff);
  color: var(--ion-color-primary-contrast, #fff);
}`, "",{"version":3,"sources":["webpack://./src/app/_components/ai-chat/ai-chat-archivio/ai-chat-archivio.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,wBAAA;EACA,8DAAA;AACF;;AAEA;EACE,OAAA;EACA,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AACF;;AAEA;EACE,cAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;AACE;EACE,2CAAA;AACJ;;AAGA;EACE,iEAAA;AAAF;;AAGA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;EACA,8BAAA;AAAF;;AAGA;EACE,OAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;AAAF;;AAGA;;EAEE,cAAA;EACA,iBAAA;AAAF;;AAGA;EACE,8BAAA;AAAF;;AAGA;EACE,cAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,2DAAA;EACA,eAAA;EACA,oCAAA;AAAF;;AAIA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,6CAAA;EACA,8CAAA;AADF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.archivio-testata {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 8px 8px 4px;\n  border-bottom: 1px solid var(--ion-color-light-shade, #e3e7ee);\n}\n\n.archivio-testata__titolo {\n  flex: 1;\n  font-size: 16px;\n}\n\n.archivio-ricerca ion-searchbar {\n  padding: 8px 12px 0;\n}\n\n.archivio-lista {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 4px 12px 16px;\n}\n\n.archivio-gruppo {\n  display: block;\n  padding: 12px 8px 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--ion-color-medium);\n  text-transform: uppercase;\n}\n\n.archivio-voce {\n  display: flex;\n  align-items: center;\n  border-radius: 10px;\n\n  &:hover {\n    background: var(--ion-color-light, #f4f6fa);\n  }\n}\n\n.archivio-voce--attiva {\n  background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.1);\n}\n\n.archivio-voce__apri {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.archivio-voce__titolo {\n  font-size: 14px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.archivio-voce__meta {\n  font-size: 12px;\n  color: var(--ion-color-medium);\n}\n\n.archivio-voce__input {\n  flex: 1;\n  margin: 4px;\n  padding: 8px;\n  border: 1px solid var(--ion-color-primary);\n  border-radius: 8px;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n}\n\n.archivio-errore,\n.archivio-vuoto {\n  display: block;\n  padding: 16px 8px;\n}\n\n.archivio-vuoto {\n  color: var(--ion-color-medium);\n}\n\n.archivio-spinner {\n  display: block;\n  margin: 12px auto;\n}\n\n.archivio-consumi {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 12px 20px;\n  border-top: 1px solid var(--ion-color-light-shade, #e3e7ee);\n  font-size: 12px;\n  color: var(--ion-color-medium-shade);\n}\n\n// Feature 164: conversazioni di contesto.\n.archivio-voce__scopo {\n  margin-right: 6px;\n  padding: 0 6px;\n  border-radius: 8px;\n  font-size: 11px;\n  font-weight: 500;\n  background: var(--ion-color-primary, #3880ff);\n  color: var(--ion-color-primary-contrast, #fff);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
